import React, { useState, useEffect } from "react";
import FiltersModalCatalogo from "./FiltersModalCatalogo";
import categories from "../Data/Categories";
import companyData from "../Data/CompanyData";
import { ciudadesPeru } from "../Data/PeruDistricts";
import { Button } from "../components/ui/button";

const FiltroCatalogo = ({ filters, setFilters, setPage, clearFilters }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("");

  useEffect(() => {
    console.log("Estado final de filters:", filters);
  }, [filters]);

  const optionsData = {
    categoria: [
      ...categories.filter((cat) => cat.label !== "Otro Servicio"),
      ...companyData.sectores,
    ].map((item) => ({ label: item.label, icon: item.icon })), // Asegurar formato correcto
    ciudad: ciudadesPeru.map((city) => ({ label: city, icon: "" })),
    puntaje: [
      { label: "5 estrellas" },
      { label: "4 estrellas" },
      { label: "3 estrellas" },
      { label: "2 estrellas" },
      { label: "1 estrella" },
    ],
  };

  const friendlyTitles = {
    categoria: "Categorías",
    ciudad: "Ciudades",
    puntaje: "Puntaje",
  };

  const handleFilterClick = (filterType) => {
    setActiveFilter(filterType);
    setIsModalOpen(true);
  };

  const handleModalApply = (filterType, value) => {
    console.log(`🔵 [FiltroCatalogo] Aplicando filtro (${filterType}):`, value);

    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value, // ❌ Aquí se guarda el label en lugar del value en puntaje
    }));

    setIsModalOpen(false);
    setPage(1);
  };

  return (
    <div className="mb-6 flex flex-wrap items-center gap-2">
      <Button
        variant={filters.categoria && filters.categoria.length > 0 ? "default" : "outline"}
        onClick={() => handleFilterClick("categoria")}
      >
        Categorías
      </Button>
      <Button
        variant={filters.ciudad && filters.ciudad.length > 0 ? "default" : "outline"}
        onClick={() => handleFilterClick("ciudad")}
      >
        Ciudades
      </Button>
      <Button
        variant={filters.puntaje && filters.puntaje.length > 0 ? "default" : "outline"}
        onClick={() => handleFilterClick("puntaje")}
      >
        Puntaje
      </Button>
      <Button
        variant={filters.certificado ? "default" : "outline"}
        onClick={() => {
          setFilters((prev) => ({ ...prev, certificado: !prev.certificado }));
          setPage(1);
        }}
      >
        Certificados
      </Button>
      <Button variant="ghost" onClick={clearFilters}>
        Limpiar Filtros
      </Button>

      {isModalOpen && (
        <FiltersModalCatalogo
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          options={optionsData[activeFilter] || []}
          selectedOptions={filters[activeFilter] || []}
          setSelectedOptions={(newOptions) =>
            handleModalApply(activeFilter, newOptions)
          }
          title={`Seleccionar ${friendlyTitles[activeFilter] || activeFilter}`}
        />
      )}
    </div>
  );
};

export default FiltroCatalogo;
